var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDotsUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "52px",
    viewBox: "0 0 51 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration/Dots-upload") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration/Dots-upload",
    transform: "translate(2.000000, 2.000000)",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4289383,36.1967213 L23.4289383,11.0163934",
    id: "Shape",
    stroke: "#002C8B"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#002C8B",
    points: "34.3624429 22.0327869 23.4289383 11.0163934 12.4954338 22.0327869"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#00B5E1",
    points: "0 6.29508197 0 0 6.24771688 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7431506,0 L28.114726,0",
    id: "Shape",
    stroke: "#00B5E1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#00B5E1",
    points: "40.6101597 0 46.8578766 0 46.8578766 6.29508197"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#00B5E1",
    points: "46.8578766 40.9180328 46.8578766 47.2131148 40.6101597 47.2131148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.114726,47.2131148 L18.7431506,47.2131148",
    id: "Shape",
    stroke: "#00B5E1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#00B5E1",
    points: "6.24771688 47.2131148 0 47.2131148 0 40.9180328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,18.8852459 L0,28.3278689",
    id: "Shape",
    stroke: "#00B5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8578766,18.8852459 L46.8578766,28.3278689",
    id: "Shape",
    stroke: "#00B5E1"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsUpload);
export default __webpack_public_path__ + "static/media/Dots-upload.b160106d.svg";
export { ForwardRef as ReactComponent };